export const ORDER_SUMMARY = 'order-summary'
export const TICKETS_DOWNLOAD = 'tickets-download'
